import { useEffect, useState } from 'react';

import { cropImage, Crop } from './ImageCropper';

export const useObjectUrl = (file: File): string | undefined => {
  const [objectUrl, setObjectUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    const url = URL.createObjectURL(file);
    setObjectUrl(url);
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  return objectUrl;
};

export async function cropImageFile(file: File, crop: Crop): Promise<Blob> {
  const objectUrl = URL.createObjectURL(file);
  let imageData: Blob;
  try {
    imageData = await cropImage(file, crop);
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
  return imageData;
}

export const getImageSize = async (file: File): Promise<{ width: number; height: number }> => {
  let imageSize: { width: number; height: number };
  const imageUrl = URL.createObjectURL(file);

  try {
    imageSize = await new Promise<{ width: number; height: number }>((resolve, reject) => {
      const image = new Image();
      image.src = imageUrl;
      image.addEventListener('load', () => resolve({ width: image.width, height: image.height }));
      image.addEventListener('error', error => reject(error));
    });
  } finally {
    URL.revokeObjectURL(imageUrl);
  }

  return imageSize;
};
